var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "inner" },
    [
      _vm.showMenu
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "on-clickaway",
                  rawName: "v-on-clickaway",
                  value: _vm.hideMenu,
                  expression: "hideMenu"
                }
              ],
              staticClass: "menu",
              style: _vm.menuStyle
            },
            [
              _vm.allowDownload
                ? _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.download($event)
                        }
                      }
                    },
                    [
                      _c("b-icon", {
                        attrs: { icon: "download", size: "is-small" }
                      }),
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("arbodocs.download")) +
                          "\n    "
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.voirApercu($event)
                    }
                  }
                },
                [
                  _c("b-icon", { attrs: { icon: "search", size: "is-small" } }),
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("arbodocs.search")) + "\n    "
                  )
                ],
                1
              ),
              _vm.allowQuestions
                ? _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.poserQuestion($event)
                        }
                      }
                    },
                    [
                      _c("b-icon", {
                        attrs: { icon: "question-circle", size: "is-small" }
                      }),
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("arbodocs.question")) +
                          "\n    "
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._l(_vm.documents, function(item) {
        return _c("div", { key: item.id, staticClass: "item" }, [
          _c(
            "span",
            {
              class: { changed: item.modified },
              on: {
                click: function($event) {
                  return _vm.click($event, item.id, item.version, item.name)
                }
              }
            },
            [
              _c("b-icon", {
                key: item.extension,
                class: _vm.getIcon(item.extension)
                  ? _vm.getIcon(item.extension)
                  : "",
                attrs: {
                  icon: _vm.getIcon(item.extension)
                    ? _vm.getIcon(item.extension)
                    : "file",
                  pack: "far",
                  size: "is-small"
                }
              }),
              _vm._v("\n      " + _vm._s(item.name) + "\n      "),
              !_vm.isRead(item.id)
                ? _c("span", { staticClass: "unread" }, [_vm._v(" * ")])
                : _vm._e()
            ],
            1
          ),
          _vm.showFiles === item.id
            ? _c(
                "div",
                { staticClass: "files" },
                _vm._l(_vm.documentFiles(item.id, item.version), function(
                  file,
                  index
                ) {
                  return _c(
                    "span",
                    {
                      key: item.id + "-" + item.version + "-" + file.id,
                      on: {
                        click: function($event) {
                          return _vm.clickFile(
                            $event,
                            item.id,
                            item.version,
                            file.id
                          )
                        }
                      }
                    },
                    [_vm._v("\n        " + _vm._s(file.name) + "\n      ")]
                  )
                }),
                0
              )
            : _vm._e()
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }